import type { ILawCardsProps } from './ILawCardsProps';

/**
 * «Аналітичні записи» (прототип v4 lzAnl): сітка карток від 280px — у кожній «НАЗВА ТИПУ» і кількість моноширинним, без записів — «—»;
 * запис — кнопка з лівою смугою тону рівня: номер з префіксом і пігулка рівня, назва, «підрядок · статус», текст.
 */
export function LawAnalysis({ sections, onOpen }: ILawCardsProps) {
  return (
    <div className="law-cards">
      {sections.map((s) => (
        <section key={s.rt} className="law-sec law-sec--tight">
          <div className="law-sec__head"><span className="law-sec__title">{s.title}</span><span className="law-sec__count">{s.cards.length}</span></div>
          {!s.cards.length && <span className="law__muted">—</span>}
          {s.cards.map((c) => (
            <button key={c.record.id} type="button" className={`law-card law-card--level law-t-${c.tone}`} onClick={() => onOpen(c.rt, c.record)}>
              <span className="law-card__top"><span className="law-card__code">{c.code}</span><span className="law-card__pill">{c.level}</span></span>
              <strong className="law-card__label">{c.label}</strong>
              <span className="law-card__meta">{c.meta} · {c.status}</span>
              <span className="law-card__text">{c.text}</span>
            </button>
          ))}
        </section>
      ))}
    </div>
  );
}
